import dayjs, {Dayjs} from "dayjs";
import {MAX_PAYMENT_DAYS} from "../../../../constants";
import {PaymentPlanFrequency} from "../../../../enums";
import {DATE_FORMAT} from "../../../../helpers";
import {nextFirstAndFifteenthDates, nextLastBusinessDayOfTheMonthDates} from "../utils";

export const getShouldDisableDate = (frequency: PaymentPlanFrequency) => {
  switch (frequency) {
    case "first_and_fifteenth":
      return disableFirstAndFifteenthDates;
    case "last_business_day_of_the_month":
      return disableLastBusinessDayOfTheMonthDates;
    default:
      return disableMaxPaymentDays;
  }
};

export const enabledDates = nextFirstAndFifteenthDates({});
export const disableFirstAndFifteenthDates = (date: Date | Dayjs) => {
  const currDate = dayjs(date).format(DATE_FORMAT);
  return !enabledDates.some((enabledDate) => {
    return currDate === enabledDate.format(DATE_FORMAT);
  });
};

export const disableLastBusinessDayOfTheMonthDates = (date: Date | Dayjs) => {
  const currDate = dayjs(date).format(DATE_FORMAT);
  return !nextLastBusinessDayOfTheMonthDates({}).some((enabledDate) => {
    return currDate === enabledDate.format(DATE_FORMAT);
  });
};

export const disableMaxPaymentDays = (date: Date | Dayjs) => {
  const currDate = dayjs(date).format(DATE_FORMAT);
  return currDate > dayjs().add(MAX_PAYMENT_DAYS, "day").format(DATE_FORMAT) || currDate < dayjs().format(DATE_FORMAT);
};
